<!-- 验证步骤组件 -->
<template id="steps">
  <div class="flows-steps">
    <div class="steps" :class="{'done': step >= 1}">
      <span class="steps-number">1</span>
      <span class="steps-title">验证身份</span>
    </div>
    <div class="steps" :class="{'done': step >= 2}">
      <span class="steps-number">2</span>
      <span class="steps-title">修改{{ title }}</span>
    </div>
    <div class="steps" :class="{'done': step >= 3}">
      <span class="steps-number steps-icon"></span>
      <span class="steps-title">完成</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['title', 'step']
  }
</script>

<style media="screen" scoped lang="scss">
  .flows-steps{
    display: flex;
    margin: 50px 0 80px;
    .steps{
      flex: 1;
      text-align: center;
      position: relative;
      &:after{
        content: "";
        width: 100%;
        height: 4px;
        background: #ddedfc;
        position: absolute;
        right: 50%;
        top: 17px;
      }
      &:first-of-type::after {
        display: none;
      }
      &.done{
         &:after{
          background: #57a3f1;
         }
        .steps-number{
          background: #57a3f1;
          border-color: #57a3f1;
          color: #fff;
          &.steps-icon{
            background: #57a3f1 url(../../images/personal_center/steps-done.png)no-repeat center center;
          }
        }
      }
      &.current{
        &:after{
          background: #57a3f1;
        }
        .steps-number{
          border-color: #57a3f1;
          color: #57a3f1;
          &.steps-icon{
            background: #fff url(../../images/personal_center/steps.png)no-repeat center center;
          }
        }
      }
      .steps-number{
        position: relative;
        z-index: 1;
        display: inline-block;
        width: 36px;
        height: 36px;
        line-height: 30px;
        color: #ddedfc;
        text-align: center;
        background: #fff;
        border-radius: 50%;
        border: 3px solid #ddedfc;
        padding: 0;
        font-size: 18px;
        font-weight: bold;
        &.steps-icon{
          background: #fff url(../../images/personal_center/steps.png)no-repeat center center;
        }
      }
      .steps-title{
        display: block;
        color: #444;
        font-size: 14px;
        margin-top: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// steps.vue?b0bed0dc